/** Portrait ratio on Wizzy SLP cards (matches wizzy-search-results-product template). */
const WIZZY_SLP_CARD_RATIO_PERCENT = "133.33%";

/** Product card / Wizzy payload prices without decimal fraction (desktop + mobile). */
function formatWizzyDisplayPrice(value) {
  if (value == null || value === "") return value;
  if (typeof value === "number") {
    return String(Math.round(value));
  }
  return String(value).replace(/(\d[\d,]*)\.\d+/g, function (match) {
    var num = parseFloat(match.replace(/,/g, ""));
    if (Number.isNaN(num)) return match;
    var rounded = Math.round(num);
    if (match.indexOf(",") >= 0) {
      return rounded.toLocaleString("en-IN");
    }
    return String(rounded);
  });
}

function formatWizzyProductPriceFields(product) {
  if (!product) return;
  ["sellingPrice", "price", "discountPrice"].forEach(function (key) {
    if (product[key] != null && product[key] !== "") {
      product[key] = formatWizzyDisplayPrice(product[key]);
    }
  });
}

function formatWizzySlpCardPrices(root) {
  var selector =
    ".wizzy-result-product .price-item, .wizzy-autocomplete-wrapper .st-sale-price, .wizzy-autocomplete-wrapper .st-main-price";
  var nodes;
  if (root instanceof Element) {
    nodes = root.matches("mm-product-card")
      ? root.querySelectorAll(".price-item")
      : root.querySelectorAll(selector);
  } else {
    nodes = document.querySelectorAll(selector);
  }
  nodes.forEach(function (el) {
    var formatted = formatWizzyDisplayPrice(el.textContent);
    if (formatted !== el.textContent) {
      el.textContent = formatted;
    }
  });
}

/** Image area only: keep ratio box after ?view=card re-render (variant image src still updates). */
function fixWizzySlpCardImageRatio(root) {
  if (window.wizzyConfig?.common?.isOnCategoryPage) return;
  let cards;
  if (root instanceof Element && root.matches("mm-product-card")) {
    cards = [root];
  } else {
    const scope =
      root instanceof Element
        ? root
        : document.querySelector(
            ".wizzy-search-wrapper:not(.wizzy-category-page)"
          );
    if (!scope) return;
    cards = scope.querySelectorAll(".wizzy-result-product mm-product-card");
  }
  cards.forEach((cardEl) => {
    const ratioInner = cardEl.querySelector(".card__inner.ratio");
    if (ratioInner) {
      ratioInner.style.setProperty(
        "--ratio-percent",
        WIZZY_SLP_CARD_RATIO_PERCENT,
        "important"
      );
    }
  });
}

function wizzyPreloadImage(src) {
  if (!src) return Promise.resolve();
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = () => resolve();
    img.src = src;
  });
}

function wizzyApplyCardInnerWishlistFixes(cardEl) {
  const wishlistBtn = cardEl.querySelector(".icon-wishlist-heart-empty");
  if (wishlistBtn) {
    wishlistBtn.removeAttribute("style");
    wishlistBtn.style.setProperty("display", "inline-block", "important");
  }
  const heartIcon = cardEl.querySelector(".heart-hulk-animation");
  if (heartIcon) {
    heartIcon.classList.add("collection-icon");
  }
}

function wizzyCopyProductCardImage(fromImg, toImg) {
  if (!fromImg || !toImg) return;
  const srcset = fromImg.getAttribute("srcset");
  if (srcset) toImg.setAttribute("srcset", srcset);
  else toImg.removeAttribute("srcset");
  const sizes = fromImg.getAttribute("sizes");
  if (sizes) toImg.setAttribute("sizes", sizes);
  else toImg.removeAttribute("sizes");
  toImg.src = fromImg.src;
  toImg.alt = fromImg.alt || "";
  if (fromImg.width) toImg.width = fromImg.width;
  if (fromImg.height) toImg.height = fromImg.height;
}

function isWizzySlpProductCard(cardEl) {
  return (
    cardEl?.matches?.("mm-product-card") &&
    cardEl.closest(".wizzy-result-product") &&
    window.wizzyConfig &&
    !window.wizzyConfig.common.isOnCategoryPage
  );
}

async function wizzySlpUpdateMediaAndPrice(cardEl, responseCard) {
  const newImg = responseCard.querySelector(".card__media img");
  const curImg = cardEl.querySelector(".card__media img");
  if (newImg?.src && curImg) {
    await wizzyPreloadImage(newImg.src);
    curImg.classList.add("wizzy-slp-img-swapping");
    await new Promise((resolve) => setTimeout(resolve, 200));
    wizzyCopyProductCardImage(newImg, curImg);
    curImg.classList.remove("wizzy-slp-img-swapping");
  }
  const newPrice = responseCard.querySelector(".card__content .price");
  const curPrice = cardEl.querySelector(".card__content .price");
  if (newPrice && curPrice) {
    curPrice.replaceWith(newPrice.cloneNode(true));
  }
  formatWizzySlpCardPrices(cardEl);
  fixWizzySlpCardImageRatio(cardEl);
  wizzyApplyCardInnerWishlistFixes(cardEl);
}

function wizzySlpRunAddToCart(card) {
  if (card.__wizzySlpAtcInFlight) return;
  card.__wizzySlpAtcInFlight = true;

  card.loader = card.loader || card.querySelector(".loading-overlay__spinner");
  card.loader?.classList.remove("hidden");

  const checkedInput = card.querySelector(".MM-variant-input:checked");
  const variantID =
    card.variantID ||
    (checkedInput && checkedInput.dataset.variantid);
  if (!variantID) {
    card.loader?.classList.add("hidden");
    card.__wizzySlpAtcInFlight = false;
    return;
  }

  card.cart =
    card.cart ||
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");
  if (!card.cart?.getSectionsToRender) {
    card.loader?.classList.add("hidden");
    card.__wizzySlpAtcInFlight = false;
    return;
  }

  const formData = {
    items: [{ id: variantID, quantity: 1 }],
    sections: card.cart.getSectionsToRender().map((section) => section.id),
    sections_url: window.location.pathname,
  };

  card.cart.setActiveElement(document.activeElement);
  card.atcBtn = card.querySelector(".add-to-bag-button");

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.items && response.items.length > 0 && response.status != 422) {
        const resultObject = response.items[0];
        resultObject.sections = response.sections;
        card.cart.renderContents(resultObject);
      } else if (card.activeRadioInput && card.activeRadioBtn && card.atcBtn) {
        card.activeRadioInput.setAttribute("disabled", "");
        card.activeRadioInput.removeAttribute("checked");
        card.activeRadioBtn.classList.remove("available");
        card.activeRadioBtn.classList.add("unavailable");
        const label = card.atcBtn.querySelector("span");
        if (label) label.innerHTML = "Sold Out";
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    })
    .finally(() => {
      if (card.cart?.classList.contains("is-empty")) {
        card.cart.classList.remove("is-empty");
      }
      card.loader?.classList.add("hidden");
      if (typeof card.initSplide === "function") {
        card.initSplide();
      }
      card.__wizzySlpAtcInFlight = false;
    });
}

function installWizzySlpSingleAtcBind(Ctor) {
  if (!Ctor?.prototype?.addATCEvent || Ctor.prototype.__wizzySlpAtcPatch) return;

  const originalInit = Ctor.prototype.init;
  const originalAddATC = Ctor.prototype.addATCEvent;

  Ctor.prototype.addATCEvent = function () {
    if (!isWizzySlpProductCard(this)) {
      return originalAddATC.apply(this, arguments);
    }
    if (this.__wizzySlpAtcBound) return;
    this.__wizzySlpAtcBound = true;

    this.addEventListener(
      "click",
      function (event) {
        if (!isWizzySlpProductCard(this)) return;

        const atcIcon = event.target.closest(".atc-icon-wrapper");
        if (atcIcon && this.contains(atcIcon)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (typeof this.showSizeVariant === "function") {
            this.showSizeVariant();
          }
          return;
        }

        const atcBtn = event.target.closest(".add-to-bag-button");
        if (!atcBtn || !this.contains(atcBtn)) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        wizzySlpRunAddToCart(this);
      },
      true
    );
  };

  Ctor.prototype.init = function () {
    if (!isWizzySlpProductCard(this)) {
      return originalInit.apply(this, arguments);
    }
    this.loader = this.querySelector(".loading-overlay__spinner");
    this.getSwatchVariants();
    this.getRadioVariants();
    this.addATCEvent();
  };

  Ctor.prototype.__wizzySlpAtcPatch = true;
}

function wizzySlpEnsureSingleAtcBind(root) {
  const Ctor = customElements.get("mm-product-card");
  if (!Ctor?.prototype?.__wizzySlpAtcPatch) return;
  const scope =
    root instanceof Element
      ? root.matches("mm-product-card")
        ? root
        : root.querySelectorAll(".wizzy-result-product mm-product-card")
      : document.querySelectorAll(
          ".wizzy-search-wrapper:not(.wizzy-category-page) .wizzy-result-product mm-product-card"
        );
  const cards = scope instanceof NodeList ? scope : scope ? [scope] : [];
  cards.forEach((card) => {
    if (isWizzySlpProductCard(card)) {
      Ctor.prototype.addATCEvent.call(card);
    }
  });
}

function installWizzySlpSmoothProductCard() {
  const Ctor = customElements.get("mm-product-card");
  if (!Ctor?.prototype?.renderProductCard) return false;
  installWizzySlpSingleAtcBind(Ctor);
  if (Ctor.prototype.__wizzySlpSmoothRenderPatched) {
    wizzySlpEnsureSingleAtcBind();
    return true;
  }

  const originalRender = Ctor.prototype.renderProductCard;
  Ctor.prototype.renderProductCard = async function () {
    if (!isWizzySlpProductCard(this)) {
      return originalRender.apply(this, arguments);
    }

    this.sectionId = this.dataset.sectionId;
    this.productHandle = this.dataset.productHandle;
    this.templateParam = "card";
    const variantUrl = `/products/${this.productHandle}?view=${this.templateParam}&variant=${this.variantID}&section=${this.sectionId}`;

    const loader = this.querySelector(".loading-overlay__spinner");
    const overlayActive = Boolean(
      this.querySelector(".card__content-image.active")
    );
    const handleBefore = this.dataset.productHandle;
    const isSizeUpdate = this.dataset.wizzySlpUpdateMode === "size";

    if (!isSizeUpdate) {
      loader?.classList.remove("hidden");
    }

    try {
      const response = await fetch(variantUrl);
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const responseCard = html.querySelector("mm-product-card");
      if (!responseCard) {
        throw new Error("Missing mm-product-card");
      }

      const responseHandle =
        responseCard.getAttribute("data-product-handle") || handleBefore;
      const sameProduct = responseHandle === handleBefore;
      const canPartial =
        this.dataset.wizzySlpUpdateMode === "size" &&
        sameProduct &&
        this.querySelector(".card__media img") &&
        responseCard.querySelector(".card__media img");

      if (canPartial) {
        await wizzySlpUpdateMediaAndPrice(this, responseCard);
      } else {
        const newImg = responseCard.querySelector(".card__media img");
        if (newImg?.src) {
          await wizzyPreloadImage(newImg.src);
        }
        this.innerHTML = responseCard.innerHTML;
        formatWizzySlpCardPrices(this);
        fixWizzySlpCardImageRatio(this);
        wizzyApplyCardInnerWishlistFixes(this);
      }

      if (overlayActive) {
        this.querySelector(".card__content-image")?.classList.add("active");
      }
      if (window.HulkappWishlist?.init) {
        window.HulkappWishlist.init();
      }
    } catch (error) {
      console.error("Wizzy SLP smooth card render failed:", error);
      if (!isSizeUpdate) {
        loader?.classList.add("hidden");
      }
      return originalRender.apply(this, arguments);
    } finally {
      if (!isSizeUpdate) {
        loader?.classList.add("hidden");
      }
    }
  };

  function wrapWizzySlpVariantMethod(methodName, updateMode) {
    const original = Ctor.prototype[methodName];
    if (!original || original.__wizzySlpWrapped) return;
    Ctor.prototype[methodName] = async function (...args) {
      if (isWizzySlpProductCard(this)) {
        this.dataset.wizzySlpUpdateMode = updateMode;
      }
      try {
        return await original.apply(this, args);
      } finally {
        if (isWizzySlpProductCard(this)) {
          delete this.dataset.wizzySlpUpdateMode;
        }
      }
    };
    Ctor.prototype[methodName].__wizzySlpWrapped = true;
  }

  wrapWizzySlpVariantMethod("variantRadioChangeMMCard", "size");
  wrapWizzySlpVariantMethod("variantSwatchChangeMMCard", "color");

  Ctor.prototype.__wizzySlpSmoothRenderPatched = true;
  wizzySlpEnsureSingleAtcBind();
  return true;
}

function scheduleWizzySlpSmoothProductCardInstall() {
  if (installWizzySlpSmoothProductCard()) return;
  let attempts = 0;
  const timerId = setInterval(() => {
    attempts += 1;
    if (installWizzySlpSmoothProductCard() || attempts >= 50) {
      clearInterval(timerId);
    }
  }, 100);
}

/** SLP size radios: theme mm-product-card.js requires class Size + unique id/for per variant. */
function fixWizzySlpSizeRadios(root) {
  if (window.wizzyConfig?.common?.isOnCategoryPage) return;
  const scope =
    root instanceof Element
      ? root
      : document.querySelector(
          ".wizzy-search-wrapper:not(.wizzy-category-page)"
        );
  if (!scope) return;
  scope.querySelectorAll(".wizzy-result-product .fieldset__sizes").forEach(
    (fieldset) => {
      const li = fieldset.closest(".wizzy-result-product");
      const listingVariantId = li?.getAttribute("data-id");
      const handle =
        fieldset.closest("mm-product-card")?.dataset.productHandle || "card";
      const userSelected = fieldset.querySelector(".MM-variant-input:checked");
      fieldset.querySelectorAll(".MM-variant-input").forEach((input) => {
        input.classList.add("Size");
        const vid = input.dataset.variantid || "";
        const uid = `wizzy-${handle}-${vid}`;
        input.id = uid;
        input.name = `Size-wizzy-${handle}`;
        const label = input.nextElementSibling;
        if (label?.matches(".MM-variant-label")) {
          label.setAttribute("for", uid);
          label.dataset.option = "Size";
        }
        if (userSelected) {
          return;
        }
        const selected = Boolean(listingVariantId && vid === listingVariantId);
        input.checked = selected;
        if (label?.matches(".MM-variant-label")) {
          if (selected) label.setAttribute("data-active", "active");
          else label.removeAttribute("data-active");
        }
      });
      if (userSelected) {
        fieldset.querySelectorAll(".MM-variant-label").forEach((label) => {
          const input = label.previousElementSibling;
          if (input?.matches(".MM-variant-input") && input.checked) {
            label.setAttribute("data-active", "active");
          } else {
            label.removeAttribute("data-active");
          }
        });
      }
    }
  );
}

document.addEventListener("DOMContentLoaded", scheduleWizzySlpSmoothProductCardInstall);

if (window.innerWidth < 768) {
  const searchIcon = document.querySelector(
    "header .st-search-box.hidden-desktop .icon-search"
  );
  const searchInput = document.querySelector(
    "#search_mini_form .wizzy-search-form .st-search-input"
  );
  if (searchIcon) {
    searchIcon.addEventListener("click", () => {
      console.log(searchInput);
      searchInput.click();
      // searchInput.foucs();
      // console.log("Search Icon is clicked");
    });
  }
}

// place the desktop autocomplete just below the search input, wherever the sticky header currently sits
const headerSection = document.querySelector(".section-header");
const WIZZY_AUTOCOMPLETE_GAP = 3;
function getVisibleWizzySearchInput() {
  var inputs = document.querySelectorAll(
    "input.wizzy-search-input, input.st-search-input, input[name='q']"
  );
  for (var i = 0; i < inputs.length; i++) {
    var rect = inputs[i].getBoundingClientRect();
    if (rect.width > 0 && rect.height > 0) return inputs[i];
  }
  return null;
}
function syncWizzyAutocompleteTop() {
  if (window.innerWidth < 768) return;
  var searchInput = getVisibleWizzySearchInput();
  var anchorBottom;
  if (searchInput) {
    anchorBottom = searchInput.getBoundingClientRect().bottom + WIZZY_AUTOCOMPLETE_GAP;
  } else if (headerSection) {
    anchorBottom = headerSection.getBoundingClientRect().bottom;
  } else {
    return;
  }
  document.documentElement.style.setProperty(
    "--wizzy-autocomplete-top",
    Math.round(Math.max(0, anchorBottom)) + "px"
  );
}
var wizzyAutocompleteTopFrame = null;
function scheduleWizzyAutocompleteTop() {
  if (wizzyAutocompleteTopFrame) return;
  wizzyAutocompleteTopFrame = requestAnimationFrame(function () {
    wizzyAutocompleteTopFrame = null;
    syncWizzyAutocompleteTop();
  });
}
window.addEventListener("scroll", scheduleWizzyAutocompleteTop, { passive: true });
window.addEventListener("resize", scheduleWizzyAutocompleteTop);
if (headerSection) {
  headerSection.addEventListener("transitionend", scheduleWizzyAutocompleteTop);
}
document.addEventListener("focusin", scheduleWizzyAutocompleteTop);
document.addEventListener("click", scheduleWizzyAutocompleteTop, true);
syncWizzyAutocompleteTop();

if (window.innerWidth > 768) {
  document.body.addEventListener("click", function (event) {
    if (
      event.target.matches(".wizzy-facet-head") ||
      event.target.matches(".facet-head-title")
    ) {
      const closestBlock = event.target.closest(
        ".wizzy-filters-facet-block.facet-block-top"
      );
      if (closestBlock) {
        positionWizzySlpTopFacetDropdown(closestBlock);
        scheduleWizzySlpDesktopFacetSelectedCounts();
      }
    }
  });
}

const addSizeKSASorting = (filter) => {
  let isJson = false;
  let isSortJson = false;
  if (typeof filter == "string") {
    isJson = true;
    filter = JSON.parse(filter);
  }
  if (typeof filter.sort == "string") {
    isSortJson = true;
    filter.sort = JSON.parse(filter.sort);
  }
  let newSort = [];
  if (filter.sort[0].field === "relevance") {
    newSort.push(
      filter.sort[0],
      {
        field: "product_ksa:float",
        order: "desc",
      },
      {
        field: "name",
        order: "asc",
      }
    );
    filter.sort.slice(1).forEach((x) => {
      if (x.field != "product_ksa:float") {
        newSort.push(x);
      }
    });
  } else {
    newSort = filter.sort;
  }

  filter.sort = newSort;
  if (isSortJson) {
    filter.sort = JSON.stringify(filter.sort);
  }
  if (isJson) {
    filter = JSON.stringify(filter);
  }
};

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (payload) {
      payload.search.configs.facets.showPriceInputRangeFields = true;
      payload.filters.configs.keepOpenedInMobileAfterApply = true;
      payload.search.configs.facets.leftFacets.mobileCollapsible = !0,
      payload.search.configs.pagination.infiniteScrollOffset = {
        desktop: 3500,
        mobile: 3700,
      };
      if (window.innnerWidth < 768) {
        wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
          {
            dom: ".Search-In-Modal-desktop.st-search-input",
            type: "text",
          },
        ];
      }

      if (window.wizzyConfig.common.isOnCategoryPage) {
        payload.common.lazyDOMConfig.contentDOMIdentifiers[0] =
          "#wizzy-shopify-collection-page-wrapper";
      } else {
        payload.common.lazyDOMConfig.contentDOMIdentifiers = [
          "#MainContent",
          ".main-content",
        ];
      }
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      data.forEach((prod) => {
        prod.attributes?.forEach((attributes) => {
          if(attributes.name === 'TRYON'){
            if(attributes.values[0].value[0] === 'Yes'){
              prod.TRY_ON = "YES";
            }
          }
          if(attributes.name === 'SKU'){
            prod.CUSTOM_SKU = attributes.values[0].value[0];
          }
        });
        if (prod.swatches) {
          if (Array.isArray(prod.swatches)) {
            prod.swatches.forEach((swatch) => {
              if (swatch.key === "colors") {
                prod.colorSwatch = swatch;
              } else {
                prod.sizeSwatch = swatch;
              }
            });
          } else if (prod.swatches.colors) {
            prod.colorSwatch = prod.swatches.colors;
          }
          if (!Array.isArray(prod.swatches) && prod.swatches.sizes) {
            prod.sizeSwatch = prod.swatches.sizes;
          }
        }
        if (prod.sizeSwatch?.values?.length) {
          prod.sizeSwatch.values.forEach((sizeVal) => {
            sizeVal.isSelected =
              String(sizeVal.variationId) === String(prod.id);
            sizeVal.isOutOfStock = sizeVal.inStock === false;
          });
        }

        prod.dataURL = prod.url.match(/\/products\/(.*?)\?variant/)[1];
        formatWizzyProductPriceFields(prod);
      });
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (data) {
      // the collection page has no size filter, so drop it here to match
      data.response.payload.facets = data.response.payload.facets.filter(
        (facet) => facet.key !== "sizes"
      );

      data.response.payload.facets.forEach((facet) => {
        if (
          window.innerWidth < 768 &&
          facet.position &&
          facet.position == "top"
        ) {
          facet.position = "left";
        }
      });
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      payload?.products?.forEach(formatWizzyProductPriceFields);
      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      data.filters.attributeFacetValuesLimit = 50;
      data.filters.enforcePriceRangeFromQuery = true;
      // if (!window.wizzyConfig.common.isOnCategoryPage) {
      console.log(data.filters);
      addSizeKSASorting(data.filters);
      // }
      // let newSort = [];
      // if (wizzyConfig.common.isOnCategoryPage) {
      //   data.filters.sort.forEach((opt) => {
      //     if (opt.field !== "relevance") {
      //       newSort.push(opt);
      //     }
      //   });
      //   data.filters.sort = newSort;
      // }

      scheduleWizzyPriceRangeSetup();
      return data;
    },
    1
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      data.attributeFacetValuesLimit = 50;
      data.enforcePriceRangeFromQuery = true;
      addSizeKSASorting(data);

      var searchform = document.querySelector(
        ".wizzy-search-form-wrapper.mf-initial "
      );
      if (searchform && searchform.classList.contains("mobileTapped")) {
        searchform.classList.remove("mobileTapped");
      }

      //remove banner and banner image for search page
      var banner = document.querySelector(
        "#shopify-section-template--23512038408559__banner"
      );
      var bannerImage = document.querySelector(
        "#shopify-section-template--23512038408559__banner_image_JmYh9c"
      );

      if (banner || bannerImage) {
        banner.style.display = "none";
        bannerImage.style.display = "none";
      }

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (payload) {
      // console.log("VIEW_RENDERED", payload.data.response.payload.total);
      if (window.wizzyConfig.common.isOnCategoryPage) {
        setTimeout(function () {
    addWizzyBorderFilter();
}, 3000);
      }
      const pageWidthDIV = document.querySelector(
        "#MainContent .page-width.scroll-trigger.animate--slide-in"
      );
      if (pageWidthDIV && pageWidthDIV.classList.contains("page-width")) {
        pageWidthDIV.className = "";
        // console.log(pageWidthDIV);
      }
      const facetWrapper = document.querySelectorAll(
        ".wizzy-filters-facet-block .wizzy-facet-body .facet-search-wrapper"
      );
      if (window.innerWidth < 768) {
        facetWrapper.forEach((facet) => {
          if (facet.classList.contains("active")) {
            facet.classList.remove("active");
          }
        });
      }

      const PageCount = document.querySelector(
        ".collection-hero .collection-hero__text-wrapper #ProductCountDesktop"
      );
      if (PageCount) {
        PageCount.innerHTML =
          payload.data.response.payload.total + " " + "products";
      }
      setTimeout(initWizzySortArrows, 0);
      scheduleWizzySlpTopFilterUiRefresh();
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      var filterClick = document.querySelectorAll(".wizzy-filters-facet-block");
      if (!window.wizzyConfig.common.isOnCategoryPage) {
        setTimeout(syncSlpSortUi, 0);
        setTimeout(function () {
          fixWizzySlpSizeRadios();
          fixWizzySlpCardImageRatio();
          formatWizzySlpCardPrices();
          wizzySlpEnsureSingleAtcBind();
        }, 0);
      }
      setTimeout(initWizzySortArrows, 0);
      scheduleWizzySlpTopFilterUiRefresh();
      return (
        filterClick.forEach(function (element) {
          element.addEventListener("click", function (e) {
            var divList = document.querySelectorAll(
              ".wizzy-filters-facet-block"
            );
            divList.forEach(function (element2) {
              element2.classList.toString() ==
                e.target.parentElement.parentNode.classList.toString() ||
                element2.classList.add("collapsed");
            });
          });
        }),
        payload
      );
    }
  );
  document.addEventListener("click", function (event) {
    if (
      window.wizzyConfig &&
      !window.wizzyConfig.common.isOnCategoryPage &&
      event.target.closest(".wizzy-search-sort-wrapper")
    ) {
      setTimeout(syncSlpSortUi, 0);
      setTimeout(syncSlpSortUi, 100);
    }
  });
  scheduleWizzySlpSmoothProductCardInstall();
  changeTemplate("wizzy-autocomplete-topproducts");
  changeTemplate("wizzy-search-wrapper");
  changeTemplate("wizzy-search-results-product");
  changeTemplate("wizzy-facet-block");
  changeTemplate("wizzy-search-summary");
  setTimeout(initWizzySortArrows, 0);
  scheduleWizzySlpDesktopFacetSelectedCounts();
  initWizzySlpMobileSortClose();
};
const changeTemplate = function (div) {
  const oldDiv = document.getElementById(div);
  const newDiv = document.getElementById(div + "-new").text;
  oldDiv.text = newDiv;
};
/*for border on mobile filter */
function getWizzySlpSortPanelTopPx() {
  let maxBottom = 0;
  [
    "#shopify-section-announcement-bar",
    ".announcement-bar-section",
    ".utility-bar",
    ".section-header",
  ].forEach(function (selector) {
    document.querySelectorAll(selector).forEach(function (el) {
      var bottom = el.getBoundingClientRect().bottom;
      if (bottom > maxBottom) maxBottom = bottom;
    });
  });
  return maxBottom > 0 ? Math.round(maxBottom) : 105;
}

function applyWizzySlpSortPanelTop() {
  document.documentElement.style.setProperty(
    "--wizzy-sort-panel-top",
    getWizzySlpSortPanelTopPx() + "px"
  );
}

function getWizzySlpSortCloseIconHtml() {
  var themeIcon = document.querySelector(
    ".mobile-facets__close .icon-close, .announcement-text .icon-close"
  );
  if (themeIcon) {
    return themeIcon.cloneNode(true).outerHTML;
  }
  return (
    '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none" class="icon icon-close" aria-hidden="true">' +
    '<path d="M15 1.51071L13.4893 0L7.5 5.98929L1.51071 0L0 1.51071L5.98929 7.5L0 13.4893L1.51071 15L7.5 9.01071L13.4893 15L15 13.4893L9.01071 7.5L15 1.51071Z" fill="black"></path></svg>'
  );
}

function wizzySlpHasFilterOverlayClasses(el) {
  return (
    el &&
    el.classList.contains("wizzy-filters-overlay") &&
    el.classList.contains("wizzy-overlay-opened")
  );
}

function isWizzySlpMobileFilterOpen() {
  return (
    wizzySlpHasFilterOverlayClasses(document.body) ||
    wizzySlpHasFilterOverlayClasses(document.documentElement)
  );
}

function removeWizzySlpMobileTopCloseBar() {
  document.body.classList.remove("wizzy-slp-sort-open", "wizzy-slp-filter-open");
  var existing = document.querySelector(".wizzy-slp-sort-top-close");
  if (existing) existing.remove();
}

function wizzySlpClearMobileFilterOverlayClasses() {
  ["wizzy-filters-overlay", "wizzy-overlay-opened"].forEach(function (cls) {
    document.body.classList.remove(cls);
    document.documentElement.classList.remove(cls);
  });
}

function closeWizzySlpMobileFilterDrawer() {
  removeWizzySlpMobileTopCloseBar();
  var filtersLeft = document.querySelector(
    ".wizzy-search-wrapper:not(.wizzy-category-page) .wizzy-search-filters-left"
  );
  if (filtersLeft) {
    filtersLeft.classList.remove("slp-filter-panel-open");
    var closeBtn = filtersLeft.querySelector(".wizzy-filters-close-btn");
    var closeButton = filtersLeft.querySelector(".wizzy-filters-close-button");
    var bg = filtersLeft.querySelector(".wizzy-filters-bg");
    if (closeBtn) {
      closeBtn.click();
    } else if (closeButton) {
      closeButton.click();
    } else if (bg) {
      bg.click();
    }
  }
  setTimeout(function () {
    if (isWizzySlpMobileFilterOpen()) {
      wizzySlpClearMobileFilterOverlayClasses();
    }
    removeWizzySlpMobileTopCloseBar();
    syncSlpSortUi();
  }, 50);
  setTimeout(syncSlpSortUi, 200);
}

function closeWizzySlpSortPanel() {
  var container = document.querySelector(
    ".wizzy-search-wrapper:not(.wizzy-category-page) .wizzy-common-select-container.slp-sort-panel-open"
  );
  if (container) {
    var options = container.querySelector(".wizzy-common-select-options");
    if (options && window.getComputedStyle(options).display !== "none") {
      var selector = container.querySelector(".wizzy-common-select-selector");
      if (selector) selector.click();
    }
  }
  document.body.removeAttribute("aria-selected");
  setTimeout(syncSlpSortUi, 0);
}

function ensureWizzySlpSortTopClose(isSortOpen, isFilterOpen) {
  if (isFilterOpen === undefined) {
    isFilterOpen = false;
  }
  var mode = isSortOpen ? "sort" : isFilterOpen ? "filter" : false;
  if (!mode) {
    removeWizzySlpMobileTopCloseBar();
    return;
  }
  document.body.classList.toggle("wizzy-slp-sort-open", mode === "sort");
  document.body.classList.toggle("wizzy-slp-filter-open", mode === "filter");
  var closeEl = document.querySelector(".wizzy-slp-sort-top-close");
  if (!closeEl) {
    closeEl = document.createElement("span");
    closeEl.tabIndex = 0;
    closeEl.className =
      "wizzy-slp-sort-top-close mobile-facets__close mobile-facets__close--no-js";
    closeEl.setAttribute("role", "button");
    closeEl.innerHTML = getWizzySlpSortCloseIconHtml();
    document.body.appendChild(closeEl);
  }
  closeEl.setAttribute(
    "aria-label",
    mode === "sort" ? "Close sort" : "Close filters"
  );
  closeEl.setAttribute("data-wizzy-slp-drawer", mode);
}

function closeWizzySlpMobileTopCloseTarget(closeEl) {
  var mode =
    (closeEl && closeEl.getAttribute("data-wizzy-slp-drawer")) || "sort";
  if (mode === "filter" || isWizzySlpMobileFilterOpen()) {
    closeWizzySlpMobileFilterDrawer();
  } else {
    closeWizzySlpSortPanel();
  }
}

function initWizzySlpMobileSortClose() {
  if (window.__wizzySlpSortCloseBound) return;
  window.__wizzySlpSortCloseBound = true;

  function syncWizzySlpSortPanelAnchor() {
    if (window.innerWidth >= 768) return;
    if (
      document.querySelector(
        ".wizzy-search-wrapper:not(.wizzy-category-page) .slp-sort-panel-open"
      ) ||
      isWizzySlpMobileFilterOpen()
    ) {
      applyWizzySlpSortPanelTop();
    }
  }
  window.addEventListener("resize", syncWizzySlpSortPanelAnchor);
  window.addEventListener("scroll", syncWizzySlpSortPanelAnchor, {
    passive: true,
  });

  var filterDrawerSyncTimer;
  var filterDrawerClassObserver = new MutationObserver(function () {
    clearTimeout(filterDrawerSyncTimer);
    filterDrawerSyncTimer = setTimeout(syncSlpSortUi, 0);
  });
  filterDrawerClassObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ["class"],
  });
  filterDrawerClassObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["class"],
  });

  document.addEventListener("click", function (event) {
    if (
      window.innerWidth >= 768 ||
      (window.wizzyConfig && window.wizzyConfig.common.isOnCategoryPage)
    ) {
      return;
    }
    if (
      event.target.closest(".wizzy-slp-sort-top-close") ||
      event.target.closest(".wizzy-slp-sort-top-close .icon-close")
    ) {
      event.preventDefault();
      closeWizzySlpMobileTopCloseTarget(
        event.target.closest(".wizzy-slp-sort-top-close")
      );
      return;
    }
    var overlay = event.target.closest(
      ".wizzy-search-wrapper:not(.wizzy-category-page) .wizzy-common-select-container.slp-sort-panel-open > .wizzy-common-select-overlay"
    );
    if (overlay && event.target === overlay) {
      closeWizzySlpSortPanel();
      return;
    }
    var filterBg = event.target.closest(
      ".wizzy-search-wrapper:not(.wizzy-category-page) .wizzy-search-filters-left .wizzy-filters-bg"
    );
    if (filterBg && event.target === filterBg && isWizzySlpMobileFilterOpen()) {
      closeWizzySlpMobileFilterDrawer();
      return;
    }
    if (event.target.closest(".wizzy-filters-mobile-entry")) {
      [0, 50, 150, 350].forEach(function (delay) {
        setTimeout(syncSlpSortUi, delay);
      });
    }
    if (
      event.target.closest(".wizzy-filters-close-button") ||
      event.target.closest(".wizzy-apply-all-button")
    ) {
      setTimeout(function () {
        removeWizzySlpMobileTopCloseBar();
        syncSlpSortUi();
      }, 0);
      setTimeout(syncSlpSortUi, 150);
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Enter" && event.key !== " ") return;
    if (!event.target.closest(".wizzy-slp-sort-top-close")) return;
    event.preventDefault();
    closeWizzySlpMobileTopCloseTarget(
      event.target.closest(".wizzy-slp-sort-top-close")
    );
  });
}

function syncSlpSortUi() {
  if (
    window.innerWidth >= 768 ||
    !window.wizzyConfig ||
    window.wizzyConfig.common.isOnCategoryPage
  ) {
    ensureWizzySlpSortTopClose(false);
    return;
  }
  applyWizzySlpSortPanelTop();
  const filterOpen = isWizzySlpMobileFilterOpen();

  const container = document.querySelector(
    ".wizzy-search-wrapper:not(.wizzy-category-page) .wizzy-search-sort-wrapper .wizzy-common-select-container"
  );
  if (!container) {
    ensureWizzySlpSortTopClose(false, filterOpen);
    if (filterOpen) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
    return;
  }

  const options = container.querySelector(".wizzy-common-select-options");
  const sortOpen =
    options && window.getComputedStyle(options).display !== "none";
  const sortPanelOpen = sortOpen && !filterOpen;
  container.classList.toggle("slp-sort-panel-open", sortPanelOpen);
  ensureWizzySlpSortTopClose(sortPanelOpen, filterOpen);
  if (sortPanelOpen) addWizzyBorderFilter(container);
  if (sortPanelOpen || filterOpen) {
    document.body.classList.add("overflow-hidden");
  } else {
    document.body.classList.remove("overflow-hidden");
  }
}

function addWizzyBorderFilter(container) {
  const root =
    container ||
    document.querySelector(".wizzy-search-sort-wrapper .wizzy-common-select-container");
  const optionsContainer = root?.querySelector(".wizzy-common-select-options");
  if (!optionsContainer) return;

  let borderFilter = optionsContainer.querySelector(".wizzy-border-filter");
  const looseOptions = optionsContainer.querySelectorAll(
    ":scope > .wizzy-common-select-option"
  );
  if (!looseOptions.length) return;

  if (!borderFilter) {
    borderFilter = document.createElement("div");
    borderFilter.className = "wizzy-border-filter";
    optionsContainer.appendChild(borderFilter);
  }
  looseOptions.forEach((option) => borderFilter.appendChild(option));
}

/* Desktop/mobile Sort By chevron: sync with Wizzy open/close (display toggled on options). */
const wizzySortArrowObservers = new WeakMap();

function setWizzySortArrowRotation(deg) {
  let style = document.getElementById("wizzy-sort-arrow-style");
  if (!style) {
    style = document.createElement("style");
    style.id = "wizzy-sort-arrow-style";
    document.head.appendChild(style);
  }
  style.textContent =
    ".wizzy-search-sort-wrapper .wizzy-common-select-container .wizzy-common-select-selector::after{transform:rotate(" +
    deg +
    "deg)!important;}";
}

function syncWizzySortArrow(optionsEl) {
  if (!optionsEl) return;
  setWizzySortArrowRotation(
    getComputedStyle(optionsEl).display === "none" ? 0 : 180
  );
}

function bindWizzySortArrow(container) {
  const selector = container.querySelector(".wizzy-common-select-selector");
  const options = container.querySelector(".wizzy-common-select-options");
  if (!selector || !options || wizzySortArrowObservers.has(options)) return;

  selector.addEventListener("click", function () {
    requestAnimationFrame(function () {
      syncWizzySortArrow(options);
      syncSlpSortUi();
    });
  });

  const observer = new MutationObserver(function () {
    syncWizzySortArrow(options);
    syncSlpSortUi();
  });
  observer.observe(options, {
    attributes: true,
    attributeFilter: ["style", "class"],
  });
  wizzySortArrowObservers.set(options, observer);
  syncWizzySortArrow(options);
}

function initWizzySortArrows() {
  document
    .querySelectorAll(
      ".wizzy-search-sort-wrapper .wizzy-common-select-container"
    )
    .forEach(bindWizzySortArrow);
}
/* Wizzy SLP Price Input (inputPrice) — collection-style From/To; slider kept for Wizzy apply */
var wizzySlpPriceHandlersReady = false;
var WIZZY_SLP_ROOT = ".wizzy-search-wrapper:not(.wizzy-category-page)";
var WIZZY_SLP_TOP_FACET_DROPDOWN_GAP = 3;
var WIZZY_SLP_PRICE_ITEM = WIZZY_SLP_ROOT + " .facet-range-item";

function wizzySlpPriceParse(val) {
  if (val == null || val === "") return null;
  var n = parseFloat(String(val).replace(/[^\d.]/g, ""));
  return Number.isFinite(n) ? Math.round(n) : null;
}

function wizzySlpPriceSliderValues(item) {
  var slider = item.querySelector(".wizzy-facet-range-slider");
  if (!slider) return null;
  if (slider.noUiSlider) {
    return slider.noUiSlider.get().map(function (v) {
      return Math.round(Number(v));
    });
  }
  var min = Number(slider.dataset.min);
  var max = Number(slider.dataset.max);
  return Number.isFinite(min) && Number.isFinite(max) ? [min, max] : null;
}

function wizzySlpPriceSummary(item) {
  var max = Number(item.querySelector(".wizzy-facet-range-slider")?.dataset.max);
  var sym = (window.wizzyConfig?.store?.currency?.symbol || "Rs.").trim();
  var amt = Number.isFinite(max)
    ? Math.ceil(max).toLocaleString("en-IN", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
    : "";
  var el =
    item.querySelector(".wizzy-price-range-summary") ||
    (function () {
      var s = document.createElement("span");
      item.prepend(s);
      return s;
    })();
  el.className = "wizzy-price-range-summary wizzy-slp-price-summary";
  el.textContent = "The highest price is " + sym + " " + amt;
}

function wizzySlpPriceWrapIsReady(wrap) {
  return !!wrap.querySelector(".wizzy-slp-price-field input");
}

function wizzySlpPriceWrapInputs(item) {
  var sym = (window.wizzyConfig?.store?.currency?.symbol || "₹").trim();
  var inputsBox = item.querySelector(".wizzy-facet-range-inputs");
  var slider = item.querySelector(".wizzy-facet-range-slider");
  var vals = wizzySlpPriceSliderValues(item);
  if (inputsBox) inputsBox.classList.add("wizzy-slp-price-fields");

  item.querySelectorAll(".wizzy-range-input-wrapper").forEach(function (wrap, i) {
    var input = wrap.querySelector("input");
    if (!input) return;

    var labelText = i ? "To" : "From";
    wrap.classList.add(
      "wizzy-price-input-field",
      "wizzy-slp-price-field-wrap",
      i ? "wizzy-slp-price-to" : "wizzy-slp-price-from"
    );

    if (wrap.dataset.wizzyPriceWrapped === "true" && wizzySlpPriceWrapIsReady(wrap)) {
      input.classList.add("wizzy-slp-price-input", "wizzy-price-input");
      return;
    }

    wrap.querySelectorAll(".wizzy-price-input-symbol, .wizzy-slp-price-field").forEach(function (node) {
      node.remove();
    });
    if (input.parentElement !== wrap) {
      wrap.appendChild(input);
    }

    wrap.dataset.wizzyPriceWrapped = "true";

    var currency = document.createElement("span");
    currency.className = "wizzy-price-input-symbol";
    currency.textContent = sym;
    wrap.appendChild(currency);

    var field = document.createElement("div");
    field.className = "wizzy-slp-price-field";
    field.appendChild(input);
    wrap.appendChild(field);

    var label = document.createElement("label");
    label.className = "wizzy-slp-price-label";
    label.textContent = labelText;
    if (!input.id) {
      input.id = "wizzy-slp-price-" + i + "-" + Math.random().toString(36).slice(2, 8);
    }
    label.htmlFor = input.id;
    field.appendChild(label);

    input.classList.add("wizzy-slp-price-input", "wizzy-price-input");
    input.setAttribute("placeholder", labelText);
    input.setAttribute("inputmode", "decimal");
    input.type = "number";
    input.min = "0";
    if (slider?.dataset.max) input.max = slider.dataset.max;
    if (vals) input.value = String(vals[i]);
    else if (slider) {
      input.value = String(i ? slider.dataset.max : slider.dataset.min);
    }
  });
}

function wizzySlpPriceSyncInputs(item) {
  var vals = wizzySlpPriceSliderValues(item);
  if (!vals) return;
  var inputs = item.querySelectorAll(".wizzy-facet-range-inputs input");
  if (inputs[0]) inputs[0].value = String(vals[0]);
  if (inputs[1]) inputs[1].value = String(vals[1]);
}

function wizzySlpPriceApply(item, applyFilter) {
  if (!item || typeof window.jQuery === "undefined") return false;
  var $ = window.jQuery;
  var $slider = $(item).find(".wizzy-facet-range-slider");
  var sliderEl = $slider[0];
  var inputs = $(item).find(".wizzy-facet-range-inputs input");
  if (!sliderEl?.noUiSlider || !inputs.length) return false;

  var rangeMin = Number($slider.data("min"));
  var rangeMax = Number($slider.data("max"));
  var minVal = wizzySlpPriceParse(inputs.eq(0).val()) ?? rangeMin;
  var maxVal =
    wizzySlpPriceParse(inputs.eq(1).val() ?? inputs.eq(0).val()) ?? rangeMax;
  minVal = Math.max(rangeMin, Math.min(minVal, rangeMax));
  maxVal = Math.max(rangeMin, Math.min(maxVal, rangeMax));
  if (minVal > maxVal) {
    var tmp = minVal;
    minVal = maxVal;
    maxVal = tmp;
  }
  sliderEl.noUiSlider.set([minVal, maxVal]);
  wizzySlpPriceSyncInputs(item);
  if (applyFilter && typeof $.fn.applyWizzyFilters === "function") {
    var handles = sliderEl.querySelectorAll(".noUi-handle");
    if (handles.length) {
      handles[handles.length - 1].dispatchEvent(
        new MouseEvent("mouseup", { bubbles: true })
      );
      handles[handles.length - 1].dispatchEvent(
        new MouseEvent("touchend", { bubbles: true })
      );
    }
    scheduleWizzyPriceRangeSetup();
    scheduleWizzySlpDesktopFacetSelectedCounts();
  }
  return true;
}

function wizzySlpPriceBindSlider(item) {
  var slider = item.querySelector(".wizzy-facet-range-slider");
  if (!slider?.noUiSlider) {
    slider?.removeAttribute("data-wizzy-price-slider-bound");
    return;
  }
  if (slider.dataset.wizzyPriceSliderBound === "true") {
    return;
  }
  slider.dataset.wizzyPriceSliderBound = "true";
  var onSliderChange = function () {
    if (!item.querySelector(".wizzy-facet-range-inputs input:focus")) {
      wizzySlpPriceSyncInputs(item);
    }
  };
  slider.noUiSlider.on("update", onSliderChange);
  slider.noUiSlider.on("change", onSliderChange);
}

function wizzySlpPriceBindInputs(item) {
  item.querySelectorAll(".wizzy-facet-range-inputs input").forEach(function (input, i, list) {
    input.removeAttribute("readonly");
    input.removeAttribute("disabled");
    if (input.dataset.wizzySlpPriceBound === "true") return;
    input.dataset.wizzySlpPriceBound = "true";
    var wrap = input.closest(".wizzy-slp-price-field-wrap");
    input.addEventListener("focus", function () {
      wrap?.classList.add("is-focused");
    });
    input.addEventListener("blur", function () {
      wrap?.classList.remove("is-focused");
      wizzySlpPriceApply(item, false);
    });
    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        wizzySlpPriceApply(item, true);
      }
    });
    input.addEventListener("change", function () {
      wizzySlpPriceApply(item, i === list.length - 1);
    });
  });
}

function wizzySlpPriceInitItem(item) {
  item.classList.add("wizzy-slp-price-range");
  wizzySlpPriceSummary(item);
  wizzySlpPriceWrapInputs(item);
  wizzySlpPriceBindSlider(item);
  wizzySlpPriceSyncInputs(item);
  wizzySlpPriceBindInputs(item);
}

function setupWizzyPriceRangeFilters() {
  if (
    window.wizzyConfig?.common?.isOnCategoryPage ||
    !document.querySelector(WIZZY_SLP_ROOT)
  ) {
    return;
  }
  document.querySelectorAll(WIZZY_SLP_PRICE_ITEM).forEach(wizzySlpPriceInitItem);
}

function scheduleWizzyPriceRangeSetup() {
  [0, 100, 300, 800, 1500].forEach(function (delay) {
    setTimeout(setupWizzyPriceRangeFilters, delay);
  });
}

/** SLP search only: re-run price From/To + desktop top dropdown panel after Wizzy re-renders. */
function scheduleWizzySlpTopFilterUiRefresh() {
  if (window.wizzyConfig?.common?.isOnCategoryPage) return;
  if (!document.querySelector(WIZZY_SLP_ROOT)) return;
  scheduleWizzyPriceRangeSetup();
  scheduleWizzySlpDesktopFacetSelectedCounts();
}

/* Desktop SLP — "N selected" in dropdown (collection .facets__header position) */
function isWizzySlpPriceFacetBlock(block) {
  if (!block) return false;
  var key = block.getAttribute("data-key") || "";
  return key === "sellingPrice" || !!block.querySelector(".facet-body-sellingPrice");
}

function countWizzySlpFacetSelected(block) {
  if (!block) return 0;
  var count = block.querySelectorAll(
    ".wizzy-facet-list-item.active:not(.facet-range-item)"
  ).length;
  if (count) return count;
  if (isWizzySlpPriceFacetBlock(block)) {
    if (block.querySelector(".facet-range-item.active")) return 1;
    var root = document.querySelector(WIZZY_SLP_ROOT);
    if (root) {
      var chips = root.querySelectorAll(".wizzy-selected-facet-list-item");
      for (var i = 0; i < chips.length; i++) {
        var label = (chips[i].textContent || "").trim().toLowerCase();
        if (label.indexOf("price") === 0 || /^rs\.|^₹/.test(label)) return 1;
      }
    }
  }
  return 0;
}

function getWizzySlpOpenTopFacetBlock() {
  var head = document.querySelector(
    WIZZY_SLP_ROOT +
      " .wizzy-search-filters-top .wizzy-filters-facet-block .wizzy-facet-head.active"
  );
  return head ? head.closest(".wizzy-filters-facet-block") : null;
}

function getWizzySlpFacetListForBlock(block) {
  if (!block) return null;
  var key = block.getAttribute("data-key");
  if (key) {
    var valuesHost = document.querySelector(
      WIZZY_SLP_ROOT +
        ' .filters-list-top-values-wrapper[data-key="' +
        key +
        '"]'
    );
    if (valuesHost) {
      var listInHost = valuesHost.querySelector(".wizzy-facet-list");
      if (listInHost) return listInHost;
    }
  }
  return block.querySelector(".wizzy-facet-list");
}

function countWizzySlpFacetSelectedInList(block, list) {
  if (list) {
    var inList = list.querySelectorAll(
      ".wizzy-facet-list-item.active:not(.facet-range-item)"
    ).length;
    if (inList) return inList;
  }
  return countWizzySlpFacetSelected(block);
}

function getWizzySlpFacetPanelScrollHost(list) {
  if (!list) return null;
  var valuesHost = list.closest(
    WIZZY_SLP_ROOT + " .filters-list-top-values-wrapper"
  );
  if (valuesHost) return valuesHost;
  return list.closest(".wizzy-filter-wrapper") || list.parentElement;
}

function removeAllWizzySlpFacetSelectedHeaders() {
  document
    .querySelectorAll(WIZZY_SLP_ROOT + " .wizzy-slp-facet-selected-header")
    .forEach(function (el) {
      el.remove();
    });
  document
    .querySelectorAll(WIZZY_SLP_ROOT + " .wizzy-slp-facet-panel-with-header")
    .forEach(function (el) {
      el.classList.remove("wizzy-slp-facet-panel-with-header");
    });
  document
    .querySelectorAll(WIZZY_SLP_ROOT + " .wizzy-slp-facet-price-panel")
    .forEach(function (el) {
      el.classList.remove("wizzy-slp-facet-price-panel");
    });
}

function ensureWizzySlpPriceDropdownShell(block, list) {
  if (!block || !list || !isWizzySlpPriceFacetBlock(block)) return;
  var scrollHost = getWizzySlpFacetPanelScrollHost(list);
  if (!scrollHost) return;
  scrollHost.classList.add("wizzy-slp-facet-panel-with-header");
  scrollHost.classList.add("wizzy-slp-facet-price-panel");
}

function ensureWizzySlpFacetSelectedHeaderBeforeList(block, list) {
  if (!block || !list || isWizzySlpPriceFacetBlock(block)) return;

  var insertParent = list.parentElement;
  var scrollHost = getWizzySlpFacetPanelScrollHost(list);
  if (!insertParent || !scrollHost) return;

  scrollHost.classList.add("wizzy-slp-facet-panel-with-header");

  var count = countWizzySlpFacetSelectedInList(block, list);
  var header = insertParent.querySelector(
    ":scope > .wizzy-slp-facet-selected-header"
  );
  if (!header) {
    header = document.createElement("div");
    header.className = "wizzy-slp-facet-selected-header";
    header.innerHTML =
      '<span class="wizzy-slp-facet-selected-count"></span>';
    insertParent.insertBefore(header, list);
  }
  var label = header.querySelector(".wizzy-slp-facet-selected-count");
  if (label) label.textContent = count + " selected";
}

function syncWizzySlpDesktopFacetSelectedCounts() {
  if (window.innerWidth < 768 || window.wizzyConfig?.common?.isOnCategoryPage) {
    return;
  }
  if (!document.querySelector(WIZZY_SLP_ROOT)) return;

  removeAllWizzySlpFacetSelectedHeaders();

  var openBlock = getWizzySlpOpenTopFacetBlock();
  if (!openBlock) return;

  var list = getWizzySlpFacetListForBlock(openBlock);
  if (!list) return;

  ensureWizzySlpFacetSelectedHeaderBeforeList(openBlock, list);
  ensureWizzySlpPriceDropdownShell(openBlock, list);
  positionWizzySlpTopFacetDropdown(openBlock);
  if (isWizzySlpPriceFacetBlock(openBlock)) {
    var priceItem =
      list.querySelector(".facet-range-item") ||
      openBlock.querySelector(".facet-range-item");
    if (priceItem) wizzySlpPriceInitItem(priceItem);
  }
}

function getWizzySlpTopFacetPanelLeftPx(facetBlock) {
  var anchor =
    facetBlock.querySelector(".wizzy-facet-head") || facetBlock;
  var positionRoot =
    facetBlock.closest(".wizzy-search-filters-top") ||
    facetBlock.closest(".wizzy-search-filters-list-top");
  if (!positionRoot) return facetBlock.offsetLeft;

  var anchorRect = anchor.getBoundingClientRect();
  var rootRect = positionRoot.getBoundingClientRect();
  return Math.round(anchorRect.left - rootRect.left);
}

function getWizzySlpTopFacetPanelTopPx(facetBlock) {
  var filtersTop = facetBlock.closest(".wizzy-search-filters-top");
  if (!filtersTop) return null;
  var anchor =
    facetBlock.querySelector(".wizzy-facet-head") || facetBlock;
  var topRect = filtersTop.getBoundingClientRect();
  var anchorRect = anchor.getBoundingClientRect();
  return Math.round(
    anchorRect.bottom -
      topRect.top +
      filtersTop.scrollTop +
      WIZZY_SLP_TOP_FACET_DROPDOWN_GAP
  );
}

function positionWizzySlpTopFacetDropdown(facetBlock) {
  if (window.innerWidth < 768 || !facetBlock) return;
  if (!facetBlock.classList.contains("facet-block-top")) return;

  if (!facetBlock.closest(".wizzy-search-wrapper:not(.wizzy-category-page)")) {
    var legacyLeft = facetBlock.offsetLeft + "px";
    document.querySelectorAll(".wizzy-facet-list").forEach(function (el) {
      el.style.left = legacyLeft;
    });
    return;
  }

  var key = facetBlock.getAttribute("data-key");
  var valuesHost =
    (key &&
      document.querySelector(
        '.wizzy-search-wrapper:not(.wizzy-category-page) .filters-list-top-values-wrapper[data-key="' +
          key +
          '"]'
      )) ||
    document.querySelector(
      ".wizzy-search-wrapper:not(.wizzy-category-page) .filters-list-top-values-wrapper"
    );

  var leftPx = getWizzySlpTopFacetPanelLeftPx(facetBlock) + "px";
  var topVal = getWizzySlpTopFacetPanelTopPx(facetBlock);
  var topPx = topVal != null ? topVal + "px" : "";

  var lists = document.querySelectorAll(
    ".wizzy-search-wrapper:not(.wizzy-category-page) .filters-list-top-values-wrapper .wizzy-facet-list"
  );

  if (
    valuesHost &&
    valuesHost.classList.contains("wizzy-slp-facet-panel-with-header")
  ) {
    valuesHost.style.left = leftPx;
    if (topPx) valuesHost.style.top = topPx;
    valuesHost.style.right = "auto";
    valuesHost.style.marginLeft = "0";
    valuesHost.style.marginRight = "0";
    valuesHost.style.transform = "none";
    lists.forEach(function (el) {
      el.style.left = "0";
      el.style.top = "0";
      el.style.right = "auto";
      el.style.transform = "none";
    });
    return;
  }

  if (valuesHost) {
    valuesHost.style.left = "";
    valuesHost.style.top = "";
    valuesHost.style.right = "";
    valuesHost.style.marginLeft = "";
    valuesHost.style.marginRight = "";
    valuesHost.style.transform = "";
  }
  lists.forEach(function (el) {
    el.style.left = leftPx;
    if (topPx) el.style.top = topPx;
    el.style.right = "auto";
    el.style.transform = "none";
  });
}

function scheduleWizzySlpDesktopFacetSelectedCounts() {
  [0, 50, 200, 400].forEach(function (delay) {
    setTimeout(syncWizzySlpDesktopFacetSelectedCounts, delay);
  });
}

function registerWizzyPriceRangeHandlers() {
  if (wizzySlpPriceHandlersReady) return;
  wizzySlpPriceHandlersReady = true;
  document.addEventListener(
    "click",
    function (e) {
      var priceHead = e.target.closest(
        WIZZY_SLP_ROOT +
          " .wizzy-filters-facet-block.facet-block-sellingPrice .wizzy-facet-head, " +
          WIZZY_SLP_ROOT +
          " .wizzy-filters-facet-block.facet-block-sellingPrice .facet-head-title"
      );
      if (priceHead) {
        scheduleWizzyPriceRangeSetup();
      }

      var topFacetHead = e.target.closest(
        WIZZY_SLP_ROOT +
          " .wizzy-search-filters-top .wizzy-facet-head, " +
          WIZZY_SLP_ROOT +
          " .wizzy-search-filters-top .facet-head-title"
      );
      if (topFacetHead && window.innerWidth >= 768) {
        scheduleWizzySlpTopFilterUiRefresh();
      }

      var btn = e.target.closest(
        WIZZY_SLP_ROOT +
          " .facet-body-sellingPrice button, " +
          WIZZY_SLP_PRICE_ITEM +
          " button, " +
          WIZZY_SLP_ROOT +
          " [data-wizzy-price-apply]"
      );
      if (!btn || btn.classList.contains("wizzy-price-range-summary")) return;
      var item = btn.closest(".facet-range-item, .wizzy-filters-facet-block");
      if (item) wizzySlpPriceApply(item, true);
    },
    true
  );
}

document.addEventListener("DOMContentLoaded", function () {
  registerWizzyPriceRangeHandlers();
  scheduleWizzyPriceRangeSetup();
  scheduleWizzySlpDesktopFacetSelectedCounts();
});

document.addEventListener(
  "change",
  function (e) {
    if (window.innerWidth < 768) return;
    if (
      e.target.closest(
        WIZZY_SLP_ROOT + " .wizzy-search-filters-top .wizzy-facet-list-item-checkbox input"
      )
    ) {
      scheduleWizzySlpDesktopFacetSelectedCounts();
    }
  },
  true
); 

// keep the search input in sync with the clicked autocomplete suggestion
function setWizzySearchInputsValue(term) {
  document
    .querySelectorAll(
      "input.wizzy-search-input, input.st-search-input, input[name='q']"
    )
    .forEach(function (input) {
      input.value = term;
    });
}

document.addEventListener(
  "click",
  function (e) {
    var link = e.target.closest(".autocomplete-link[data-searchterm]");
    if (!link) return;
    var term = link.getAttribute("data-searchterm");
    if (!term) return;
    setWizzySearchInputsValue(term);
    setTimeout(function () {
      setWizzySearchInputsValue(term);
    }, 300);
  },
  true
);
